/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type thirdparty_SupplierCreateRequest = {
    active?: boolean;
    /**
     * AdapterClass — bắt buộc khi supplier_type="reservation": định tuyến sang adapter-service (vd
     * "timeslot" cho court booking). Không dùng cho csv/api.
     */
    adapter_class?: string;
    api_config?: any;
    commission_rate?: number;
    csv_config?: any;
    currency?: string;
    name: string;
    settlement_days?: number;
    slug: string;
    supplier_code?: string;
    supplier_type: thirdparty_SupplierCreateRequest.supplier_type;
};
export namespace thirdparty_SupplierCreateRequest {
    export enum supplier_type {
        CSV = 'csv',
        API = 'api',
        RESERVATION = 'reservation',
    }
}

